<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="关联单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getAccountFlowListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAccountFlowListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="变动类型：">
                <el-select v-model="searchForm.flowType" clearable>
                    <el-option label="入账" value="1"></el-option>
                    <el-option label="出账" value="2"></el-option>
                </el-select>
            </el-form-item>

            <el-button type="danger" plain icon="el-icon-delete" class="onlyBtn" @click="batchOptVisible1=true">批量删除流水</el-button>
            <el-form-item>
                <el-button type="primary" @click="getAccountFlowListHandler" plain icon="el-icon-search">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column> 
            <el-table-column label="ICCID号" width="180" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToUserBalance(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column label="关联单号" width="220" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0)"
                    v-if="scope.row.orderNo.indexOf('JD')==0 ||
                    scope.row.orderNo.indexOf('WX')==0 ||
                    scope.row.orderNo.indexOf('YE')==0 ||
                    scope.row.orderNo.indexOf('LS')==0 " 
                    @click="jumpByOrderNo(scope.row.orderNo)">{{ scope.row.orderNo }}</a>

                    <span v-else>{{ scope.row.orderNo }}</span>
                </template>
            </el-table-column>
            <el-table-column  prop="mobile" label="手机号" width="180" align="center"></el-table-column>
            <el-table-column  prop="amount" label="变动金额（元）" width="120" align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.flowType == 1" style="color: green;">+{{ scope.row.amount/100 }}</span>
                    <span v-if="scope.row.flowType == 2" style="color: red;">-{{ scope.row.amount/100 }}</span>
                </template>
            </el-table-column>

            <el-table-column  label="变动类型" width="100" align="center">
                <template slot-scope="scope">
                	<span v-if="scope.row.flowType == 1" style="color: green;">入账</span>
                    <span v-if="scope.row.flowType == 2" style="color: red;">出账</span>
                </template>
            </el-table-column>
            <el-table-column  label="变动时间" width="180" align="center">
                <template slot-scope="scope">
                    {{dateFormat('yyyy-MM-dd hh:mm:ss', new Date(scope.row.createTime))}}
                </template>
            </el-table-column>
            <el-table-column  prop="remark" label="备注" align="center"></el-table-column>
        </el-table>
        
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>


        <el-dialog :append-to-body="true"  title="批量删除" :visible.sync="batchOptVisible1" width="600px" @close="batchOptVisible1=false" :close-on-click-modal="false">
            <el-form ref="batchOptForm1" :model="batchOptForm1"  label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/change/update/simLog')" :headers="setHeader()" :auto-upload="false" :data="batchOptForm" :on-change="handleChange" :on-success = 'handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/mould/download?type=delete')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="batchOptVisible1=false">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>   

                 
    </div>
</template>
<script>
import { getAccountFlowRecordList, getUserBalance} from '@/api/record.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            batchOptVisible1:false,
            batchOptForm1:{

            },
            searchForm: {
                iccid: '',
                orderNo: '',
                payState:null,
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },
    methods: {
        sureBatchChgStateHandler1(){ 
            this.$refs.batchOptForm1.validate(valid => {
                if(valid) {           
                    this.$refs.upload.submit();
                }
            });
        },
        getAccountFlowListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);   
            getAccountFlowRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })   

        },

        goToUserBalance(row){
            this.$store.commit('menu/setFromPage', 'balanceRechargeRecord');
            this.$store.commit('menu/setIccidToAccount', row.iccid);
            document.getElementById('userBalanceMenu').click();
        },


        jumpByOrderNo(orderNo){
            //余额支付则跳转到订单管理
            if(orderNo.indexOf("YE")==0){
                this.$store.commit('menu/setFromPage', 'userAccountFlowRecord');
                this.$store.commit('menu/setToOrderMgtOrderNo', orderNo);
                document.getElementById('orderMgtMenu').click();
            }
            //微信、京东支付跳转充值记录
            else if(orderNo.indexOf("WX")==0 || orderNo.indexOf("JD")==0 || orderNo.indexOf("LS")==0){
                this.$store.commit('menu/setFromPage', 'userAccountFlowRecord');
                this.$store.commit('menu/setFromPageOrderNo', orderNo);
                document.getElementById('balanceRechargeRecordMenu').click();
            }
            
        },

      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAccountFlowListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAccountFlowListHandler();
        }  
    },
    created () {
        this.getAccountFlowListHandler()
    }
}
</script>
<style lang="less" scoped>

</style>

